import React, { useContext } from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import { Role } from "../enums/enums";
import Home from "../components/home/Home";
import Dashboard from "../components/dashboard/Dashboard";
import Agreement from "../components/agreement/Agreement";
import AgreementCreate from "../components/agreement/AgreementCreate";
import AgreementMassiveCreate from "../components/agreement/AgreementMassiveCreate";
import Product from "../components/product/Product";
import ProductCreate from "../components/product/ProductCreate";
import ProductEdit from "../components/product/ProductEdit";
import TypeAssistant from "../components/type-assistant/Type-Assistant";
import PaymentMethod from "../components/payment-method/PaymentMethod";
import PaymentMethodAssign from "../components/payment-method/PaymentMethodAssign";
import PaymentMethodList from "../components/payment-method/PaymentMethodList";
import Categories from "../components/categories/Categories";
import User from "../components/users/User";
import SalesChannel from "../components/salesChannel/SalesChannel";
import ExternalSalesChannel from "../components/external-sales-channel/ExternalSalesChannel";
import Email from "../components/email/Email";
import AgreementConfirm from "../components/agreement/AgreementConfirm";
import AgreementCancel from "../components/agreement/AgreementCancel";
import { ProtectedRoute } from "../components/common/protectedRoute";
import { MainContext } from "../context/MainContext";
import { useSelector } from "react-redux";
import { Sales } from "../components/sales/processSales";
import { DemandRequest } from "../components/demand/DemandRequest";

const PrivateRoute = () => {
  const { setDataToast, setIsLoading } = useContext(MainContext);
  const { decoded } = useSelector((state) => state.authReducer);

  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/solicitud-baja/:tipoSolicitudId"
          element={
            <DemandRequest
              setIsLoading={setIsLoading}
              setDataToast={setDataToast}
            />
          }
        />
        <Route
          path="/contrato/:hash/confirmar"
          element={
            <AgreementConfirm
              setIsLoading={setIsLoading}
              setDataToast={setDataToast}
            />
          }
        />
        <Route
          path="/contrato/cancelar"
          element={
            <AgreementCancel
              setIsLoading={setIsLoading}
              setDataToast={setDataToast}
            />
          }
        />
        <Route
          path="/"
          element={
            <Home setDataToast={setDataToast} setIsLoading={setIsLoading} />
          }
        >
          <Route
            path="/inicio"
            exact
            element={
              <ProtectedRoute setDataToast={setDataToast} role={[Role.All]}>
                <Dashboard
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* Agreement Section */}
          <Route
            path="/contrato"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]}
              >
                <Agreement
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contrato/crear"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.InternalSeller, Role.ExternalSeller]}
              >
                <AgreementCreate
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contrato/creacion-masiva"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]}
              >
                <AgreementMassiveCreate
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* Product Section */}
          <Route
            path="/producto"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]}
              >
                <Product
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/producto/crear"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]}
              >
                <ProductCreate
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/producto/:id/editar"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]}
              >
                <ProductEdit
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* TypeAssistant Section */}
          <Route
            path="/tipos-asistencias"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial]}
              >
                <TypeAssistant
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tipos-asistencias?estado=1"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial]}
              >
                <TypeAssistant
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* PaymentMethod Section */}
          <Route
            path="/medios-pago"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial]}
              >
                <PaymentMethod
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/medio-de-pago/asignar"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial]}
              >
                <PaymentMethodAssign
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/medios-pago?estado=1"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial]}
              >
                <PaymentMethodList
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* CategoriesMethod Section */}
          <Route
            path="/categoria"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial]}
              >
                <Categories
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* Users Section */}
          <Route
            path="/usuario"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial, Role.AdminIT]}
              >
                <User setDataToast={setDataToast} setIsLoading={setIsLoading} />
              </ProtectedRoute>
            }
          />

          {/* Sales Channel Section */}
          <Route
            path="/canales-venta"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial, Role.AdminIT]}
              >
                <SalesChannel
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/canales-venta/externos"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial, Role.AdminIT]}
              >
                <ExternalSalesChannel
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* Sales Section */}
          <Route
            path="/procesar-ventas"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.InternalSeller]}
              >
                <Sales
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />

          {/* Email Section */}
          <Route
            path="/email"
            exact
            element={
              <ProtectedRoute
                setDataToast={setDataToast}
                role={[Role.AdminComercial, Role.AdminIT]}
              >
                <Email
                  setDataToast={setDataToast}
                  setIsLoading={setIsLoading}
                />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <Navigate
              to={
                decoded.role === Role.InternalSeller ||
                decoded.role === Role.ExternalSeller
                  ? "/contrato"
                  : "/inicio"
              }
              replace
            />
          }
        />
      </Routes>
    </>
  );
};

export default PrivateRoute;
